export default __webpack_public_path__ + "static/media/iconDashboard.72a2ed35.svg";